/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_S4Inputs */

const en_tut_tampilan_s4 = /** @type {(inputs: Tut_Tampilan_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch the interface language between Bahasa Indonesia and English from the \`⌘K\` command box.`)
};

const id_tut_tampilan_s4 = /** @type {(inputs: Tut_Tampilan_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti bahasa antarmuka antara Bahasa Indonesia dan English lewat kotak perintah \`⌘K\`.`)
};

/**
* | output |
* | --- |
* | "Switch the interface language between Bahasa Indonesia and English from the `⌘K` command box." |
*
* @param {Tut_Tampilan_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_s4 = /** @type {((inputs?: Tut_Tampilan_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_s4(inputs)
	return en_tut_tampilan_s4(inputs)
});